import { useEffect,useState} from "react";
import TourneyCard from './TourneyCard';

import SmashBuzzApi from "../api/api.js";

var clearLoading = () => {
  document.getElementsByName('loading-tournaments')[0].style.display="none";
}

export default function TourneyCardList() {
  const [tourneyData,setTourneyData] = useState([]);

  // get tournament data on mount
  useEffect( () => {
    SmashBuzzApi.getTournaments()
      .then( response => {
        //console.log("Fetched Tournament Data");
        setTourneyData(response);
        clearLoading();
      })
      .catch( error =>{
        console.log("Error- Could not get tournament data: "+error);
      })
  },[]);

  const tourneyCardList = () => {
    return tourneyData.map(function(tournament, i){
      return <div style={{marginBottom:"50px"}}><TourneyCard  tournament={tournament} key={i} /></div>;
    })
  }

  return (
    <div>
      <h3>Tournament List</h3>
      <h4 name="loading-tournaments">Loading...</h4>
      { tourneyCardList() }
    </div>
  )
}
